import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type TrainingModuleReview = {
  displayInfo: {
    program: {
      displayName: string
      color: string
      iconType: string | null
      engagementCount: number
    }
    module: {
      title: string
      description: string
    }
  }
  trainingReview: {
    sessionId: string
    dateClosed: string
    accuracy: number
    targetAccuracy: number
    targetResolution: number
    totalTimeToClose: number
    engagements: Engagement[]
  }[]
}

type Engagement = {
  location: string
  isCorrect: boolean
  engagementId: string
  timeToClose: number
}

export const useGetTrainingModuleReview = (trainingModuleId?: string, operatorId?: string) => {
  return useQuery({
    queryKey: ['training-module-review', trainingModuleId],
    queryFn: async () => {
      const url = operatorId
        ? `int/v3/operators/training-review/${operatorId}` // Admin only!
        : 'int/v3/operators/training-review/mine'

      const { data } = await apiClient.get<TrainingModuleReview>(url, {
        params: { trainingModuleId },
      })

      return data
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(trainingModuleId),
  })
}
